var BulkTaxReportModule = (function () {
    function BulkTaxReportModule() {
    }
    return BulkTaxReportModule;
}());
export { BulkTaxReportModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/bulk-tax-report/bulk-tax-report.module.ts.pre-build-optimizer.js